module.exports = __webpack_public_path__ + "img/thumb_Curious.577c8739.jpg";